import "./index.css";
import logo from "../../assets/logo.png"
import React, { useRef, useEffect, useState } from 'react';
import { Tabs, Button, Checkbox, Form, Input } from 'antd';
import { useNavigate } from "react-router-dom";
export default function Index() {
    const navigate = useNavigate()
    // 判断登录或者注册状态
    const [sta, usesta] = useState('登录')
    // 点击切换tab
    const onChange = (key) => {
        console.log(key, 'kwy');
        if (key == '1') {
            usesta('登录')
        }
        if (key == '2') {
            usesta('注册')
        }
    };
    // 登录
    const onFinish = (values) => {
        console.log('登录:', values);
        if (values.username == "admin" && values.password == "123456" && values.remember == true) {
            console.log("登录成功")
            localStorage.setItem("zw_token","afadaadwada")
            navigate('/index',{})

        }
    };
    // 注册
    const onEnroll = (values) => {
        console.log('注册:', values);
    };
    const items = [
        {
            key: '1',
            label: (<div style={{ color: 'black', fontSize: '20px' }}>登录</div>),
            children: (<div style={{ marginRight: '90px', marginTop: '30px' }}>
                <Form
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    style={{
                        maxWidth: 600,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    // onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item
                        label="账号"
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: '请输入账号!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="密码"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: '请输入密码!',
                            },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item
                        name="remember"
                        valuePropName="checked"
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Checkbox>我已阅读并同意协议</Checkbox>
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit" block>
                            登录
                        </Button>
                    </Form.Item>
                </Form>
            </div>),
        },
        {
            key: '2',
            label: (<div style={{ color: 'black', fontSize: '20px' }}>注册</div>),
            children: (
                <div style={{ marginRight: '90px', marginTop: '30px' }}>
                    <Form
                        name="basic"
                        labelCol={{
                            span: 8,
                        }}
                        wrapperCol={{
                            span: 16,
                        }}
                        style={{
                            maxWidth: 600,
                        }}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onEnroll}
                        // onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            label="账号"
                            name="username"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入账号!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="密码"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入密码!',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            label="确认密码"
                            name="ConfirmPassword"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入密码!',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            name="remember"
                            valuePropName="checked"
                            wrapperCol={{
                                offset: 8,
                                span: 16,
                            }}
                        >
                            <Checkbox>我已阅读并同意协议</Checkbox>
                        </Form.Item>

                        <Form.Item
                            wrapperCol={{
                                offset: 8,
                                span: 16,
                            }}
                        >
                            <Button type="primary" htmlType="submit" block>
                                注册
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            ),
        }
    ];
    return (
        <div className="login_box">
            <div className="box_img">
                <div className="ico">
                    {/* <img className="tubiao" src={logo} alt="" /> */}
                </div>
                <div className="content">
                    <div className="biaoti">科技</div>
                    <div className="biaoti">让工厂变得更加聪明</div>
                </div>
                <div className="subscript"></div>
            </div>
            <div className="box_ipt">
                <div className="ipt_biaoti">欢迎{sta}</div>
                <Tabs defaultActiveKey="1" centered="true" tabBarStyle={{ border: '1px solid white', fontSize: '20px' }} items={items} onChange={onChange} />
            </div>
        </div>
    );
}
